import { Plus } from "@phosphor-icons/react";
import clsx from "clsx";

import Alert from "common/components/ui/Alert";
import { Button } from "common/components/ui/Button";

import { useCampaignFlowContext } from "../../../context/CampaignFlowContext";
import CampaignPausedTooltip from "../CampaignPausedTooltip";

interface PlaceholderProps {
  onAdd: () => void;
  type: "inmail" | "message" | "note";
  isDisabled?: boolean;
  shouldShowPremiumBanner?: boolean;
}

const typeTitle: Record<PlaceholderProps["type"], string> = {
  inmail: "Add a InMail",
  message: "Add a Follow-Up Message",
  note: "Add a Connection Note",
};

export default function Placeholder({
  onAdd,
  type,
  isDisabled = false,
  shouldShowPremiumBanner = false,
}: PlaceholderProps) {
  const { canEditFlow } = useCampaignFlowContext();
  const isPlaceholderDisabled = !canEditFlow || isDisabled;

  const commonWrapperClassNames = "flex items-center rounded-3xl border";

  if (shouldShowPremiumBanner)
    return (
      <Alert variant="warning">
        <span className="text-xs-bold">Notes not available.</span> Free LinkedIn
        accounts can only send 5 connection notes / month. Upgrade to premium to
        add notes to your campaigns
      </Alert>
    );

  return (
    <CampaignPausedTooltip isEditingDisabled={!canEditFlow}>
      <button
        type="button"
        onClick={onAdd}
        disabled={isPlaceholderDisabled}
        className={clsx(
          "group gap-x-2 rounded-3xl border-dashed border-black-300 bg-white p-3 transition-colors hover:bg-whiteGray disabled:cursor-not-allowed disabled:bg-black-100",
          commonWrapperClassNames,
        )}
      >
        <Button
          intent="labelIcon"
          size="xs"
          disabled={isPlaceholderDisabled}
          className="group-disabled:bg-black-200 group-disabled:text-black-950"
        >
          <Plus />
        </Button>

        <h5 className="text-left text-button-sm group-disabled:text-black-400">
          {typeTitle[type]}
        </h5>
      </button>
    </CampaignPausedTooltip>
  );
}
